import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl-next';
import Select, { AsyncSelect } from '@atlaskit/select';
import { getDropDownMenuPosition } from '../common/commonDropDownMenuProps';
import { SelectErrorContainer } from '../common/questionWrappers';
import { EditOtherOption } from './EditOtherOption';
import { messages } from './messages';
export var EditDropdown = function EditDropdown(_ref) {
  var id = _ref.id,
    options = _ref.options,
    value = _ref.value,
    loading = _ref.loading,
    loadOptions = _ref.loadOptions,
    onChange = _ref.onChange,
    hasOtherOption = _ref.hasOtherOption,
    otherOptionSelected = _ref.otherOptionSelected,
    otherOptionText = _ref.otherOptionText,
    onOtherOptionTextChange = _ref.onOtherOptionTextChange,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    customComponents = _ref.customComponents,
    label = _ref.label;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasBeenFocused = _useState2[0],
    setHasBeenFocused = _useState2[1];
  if (loadOptions === undefined) {
    return /*#__PURE__*/React.createElement(SelectErrorContainer, {
      isInvalid: isInvalid
    }, /*#__PURE__*/React.createElement(Select, _extends({
      id: id,
      options: options,
      value: value !== null && value !== void 0 ? value : null,
      isLoading: loading,
      onChange: onChange,
      isSearchable: true,
      noOptionsMessage: function noOptionsMessage() {
        return /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownNoOptions);
      },
      placeholder: /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownSelect),
      isRequired: isRequired
    }, getDropDownMenuPosition(), {
      label: label
    })), hasOtherOption && otherOptionSelected && /*#__PURE__*/React.createElement(EditOtherOption, {
      dropdown: true,
      value: otherOptionText,
      isDisabled: !otherOptionSelected,
      onChange: onOtherOptionTextChange,
      id: id
    }));
  }
  return /*#__PURE__*/React.createElement(SelectErrorContainer, {
    isInvalid: isInvalid
  }, /*#__PURE__*/React.createElement(AsyncSelect, _extends({
    autoFocus: hasBeenFocused,
    defaultMenuIsOpen: hasBeenFocused,
    defaultOptions: hasBeenFocused,
    id: id,
    isSearchable: true,
    key: id + hasBeenFocused,
    isLoading: loading,
    noOptionsMessage: function noOptionsMessage() {
      return /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownNoOptions);
    },
    loadOptions: loadOptions,
    loadingMessage: function loadingMessage() {
      return /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownLoading);
    }
  }, getDropDownMenuPosition(), {
    onChange: onChange,
    onFocus: function onFocus() {
      return setHasBeenFocused(true);
    },
    placeholder: /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownSelect),
    value: value !== null && value !== void 0 ? value : null,
    components: customComponents,
    label: label
  })));
};